function isTypingInEditable(el) {
  if (!el) return false;
  const tag = (el.tagName || '').toUpperCase();
  return (
    tag === 'INPUT' ||
    tag === 'TEXTAREA' ||
    tag === 'SELECT' ||
    Boolean(el.isContentEditable)
  );
}

/** Letter shortcuts must not fire while typing in search or other fields. */
function shouldStealQuickEmailShortcut(event) {
  return !isTypingInEditable(event && event.target);
}

/** Delete key matches the trashcan for the email currently on screen. */
function emailIdForDeleteKey(state) {
  const row = state || {};
  if (row.key !== 'Delete') return null;
  if (!row.pointerOverPanel || !row.stealShortcut || row.dialogOpen) return null;
  if (row.emailId == null || row.emailId === '') return null;
  return row.emailId;
}

module.exports = {
  isTypingInEditable,
  shouldStealQuickEmailShortcut,
  emailIdForDeleteKey,
};
